import React, { useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import { SuccessIcon, IdleIcon, RunningIcon, IconButton, } from '@miroculus/nucleo';
import { OverflownTooltipText } from 'components';
import { secondsToTime } from 'utils';
import styles from './InstrumentCard.scss';
import { CgDetailsMore } from 'react-icons/cg';
import { instrumentDetailsUrl } from 'cons/routes';
const cx = classnames.bind(styles);
const InstrumentBodyContent = ({ size, id, givenName, organizationName, organizationSlug, hideDetailsButton, }) => {
    return (React.createElement("div", { className: cx('instrument-card-body', size) },
        React.createElement("div", null,
            React.createElement(OverflownTooltipText, { tooltipLabel: givenName },
                React.createElement("h2", null, givenName)),
            React.createElement(OverflownTooltipText, { tooltipLabel: organizationName },
                React.createElement("h3", null, organizationName)),
            size !== 'small' && (React.createElement(OverflownTooltipText, { tooltipLabel: `miroID: ${id}` },
                React.createElement("h3", null,
                    "miroID: ",
                    id)))),
        size !== 'small' && !hideDetailsButton && (React.createElement("span", { onClick: (e) => e.stopPropagation() },
            React.createElement(IconButton, { label: "Details", to: instrumentDetailsUrl(organizationSlug, id), "data-testid": `details-button-${id}` },
                React.createElement(CgDetailsMore, { size: "1.5em" }))))));
};
const CurrentTimeAndUser = ({ startedAt, user }) => {
    const [runningTime, setRunningTime] = useState(startedAt ? (Date.now() - startedAt) / 1000 : 0);
    useEffect(() => {
        const interval = setInterval(() => {
            setRunningTime(startedAt ? (Date.now() - startedAt) / 1000 : 0);
        }, 1000);
        return () => clearInterval(interval);
    }, [startedAt]);
    const { h, m, s } = secondsToTime(runningTime);
    return (React.createElement("h5", { className: cx('timeCounter') },
        user,
        " | ",
        h,
        ":",
        m,
        ":",
        s));
};
const InstrumentFooterContent = ({ size, startedAt, user, status, connected, version, }) => {
    const getStatusLabel = () => {
        if (!connected) {
            return (React.createElement("div", { className: cx('instrumentStatus') },
                React.createElement(IdleIcon, null),
                React.createElement("h4", { className: cx('status') }, "Offline")));
        }
        switch (status) {
            case 'Busy':
                return (React.createElement("div", { className: cx('instrumentStatus') },
                    React.createElement(RunningIcon, null),
                    React.createElement("div", null,
                        React.createElement("h4", { className: cx('status') }, startedAt ? 'Running' : 'Setting experiment'),
                        React.createElement(CurrentTimeAndUser, { startedAt: startedAt, user: user }))));
            case 'Complete':
                return (React.createElement("div", { className: cx(['instrumentStatus', 'complete']) },
                    React.createElement(SuccessIcon, null),
                    React.createElement("h4", { className: cx('status') }, "Complete")));
            case 'Available':
                return (React.createElement("div", { className: cx('instrumentStatus') },
                    React.createElement(SuccessIcon, null),
                    React.createElement("h4", { className: cx('status') }, "Available")));
            case 'Missing':
            case 'Disconnected':
            case 'Offline':
                return (React.createElement("div", { className: cx('instrumentStatus') },
                    React.createElement(IdleIcon, null),
                    React.createElement("h4", { className: cx('status') }, "Inactive")));
            default:
                break;
        }
    };
    return (React.createElement("div", { className: cx('instrument-card-footer') },
        getStatusLabel(),
        size !== 'small' && React.createElement("p", { className: cx('version') },
            "Version: ",
            version)));
};
const InstrumentCard = ({ onClick = () => { }, disabled, size = 'big', id, givenName, organizationName, organizationSlug, status, startedAt, connected, version, user, hideDetailsButton, ...rest }) => (React.createElement("div", { "data-testid": rest['data-testid'], className: cx('instrument-card', size, { disabled }), onClick: disabled ? undefined : onClick },
    React.createElement(InstrumentBodyContent, { id: id, givenName: givenName, organizationName: organizationName, organizationSlug: organizationSlug, size: size, hideDetailsButton: hideDetailsButton }),
    React.createElement(InstrumentFooterContent, { status: status, startedAt: startedAt, connected: connected, user: user, version: version, size: size })));
export default InstrumentCard;
